/* 荀攸（字公達） */
import { gd, spMul } from '../../core/kit.ts';
import type { Unit } from '../types.ts';
import { defineHero, hook, P, D } from '../define.ts';

export default defineHero({
  id: 'xunyou', name: '荀攸', sub: '字公達', faction: 'wei', role: '法師', weapon: 'staff',
  look: { head: 'guan', robe: true, beard: 'goatee', fx: '#7fc8ff', c: { cloth: '#2f4a6a', sleeve: '#2f4a6a', pole: '#3a3020' } },
  skills: [
    ['謀攻', 'bolt', '朝方向射出謀略飛書，命中第一個敵人造成 {63/105/145/185} 傷害，之後 4 秒內的下一次普攻再附加同等傷害。', { x: { k: 'plot', dmg: [63, 105, 145, 185] }, aim: D(750, 24), cd: 8, mp: [60, 70, 80, 90], el: null }],
    ['決水灌城', 'trap', '指定區域變成江水 {6/7/8/9} 秒：敵人緩速 30% 而且是濕的（觸發導電、凍結等元素反應）；水中的敵方建築每秒受到 {20/30/40/50} 傷害。', { x: { k: 'flood', r: 240, dur: [6, 7, 8, 9], bld: [20, 30, 40, 50] }, aim: P(650, 240), cd: [24, 22, 20, 18], mp: 100, el: 'ice' }],
    ['深密', 'passive', '技能冷卻 -{3/6/9/12}%。', { pv: { cdr: [3, 6, 9, 12] } }],
    ['十二奇策', 'command', '立即再放一次上一個小技能（免耗氣、不進冷卻），傷害 +{20/35/50}%。', { x: { k: 'twelve', boost: [20, 35, 50] }, aim: D(750, 24), cd: [40, 32, 24], mp: [100, 120, 140], el: null, shout: '奇策十二，此其一也。' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    plot(u, a, X) {
      const dmg = X.dmg * spMul(u);
      this.shootProj(u, { dir: a.dir, speed: 1000, range: this.skillRange(a.sk, a.lvl), rad: 18, shape: 'orb', col: '#7fc8ff', big: true,
        onHit: (t: Unit) => { this.damage(u, t, dmg, { magic: true, spell: true, stagger: 0.25 }); u.plotB = { dmg, until: this.t + 4 }; return true; } });
    },
    flood(u, a, X) {
      this.zone(u, { x: a.pt[0], y: a.pt[1], r: X.r, t: X.dur, dur0: X.dur, tick: 0.5, slow: 0.3, name: a.sk.name, x2: { flood: true, bld: X.bld } });
      this.fx({ k: 'fire', x: a.pt[0], y: a.pt[1], pal: 'ice' });
    },
    twelve(u, a, X) {
      const i = u.lastSk;
      if (i == null || !u.skillLv[i]) { this.xRefund(u, a); this.tell(u, '十二奇策：還沒有放過小技能', 'warn'); return; }
      const pt = a.pt;
      this.later(0.02, () => {
        if (!u.alive || u.st.stun > 0) return;
        const base = u.sp || 0, sk = u.spec.skills[i];
        u.sp = base + X.boost;
        this.beginSkill(u, i, sk, u.skillLv[i], pt[0], pt[1]);
        this.later(3, () => { if (u.sp === base + X.boost) u.sp = base; });
        if (u.human) this.tell(u, `十二奇策：再放一次「${sk.name}」`, 'info');
      });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 謀攻：下一次普攻附加傷害
    hook('attack', 40, function (u, a, next) {
      const t = a.target;
      if (u.plotB && t && t.alive && t.team !== u.team) {
        const b = u.plotB; u.plotB = null;
        if (b.until > this.t) this.later(u.ranged ? 0.35 : 0, () => { if (t.alive) { this.damage(u, t, b.dmg, { magic: true, spell: true }); this.fx({ k: 'spark', x: t.x, y: t.y - 40, col: '#7fc8ff' }); } });
      }
      return next();
    }),
    // 十二奇策：記住上一個放出的小技能
    hook('cast.ok', 10, function (u, i) { if (i < 3) u.lastSk = i; }),
    // 決水灌城：水淹區域，建築持續受傷、單位被淹
    hook('zone', 30, function (z, dt) {
      const e = z.x2;
      if (e.flood) for (const t of this.units) {
        if (!t.alive || gd(z.x, z.y, t.x, t.y) > z.r) continue;
        if (t.structure) { if (t.team !== z.team && t.team < 2 && !this.structureLocked(t)) this.damage(z.owner, t, e.bld * dt, { magic: true, quiet: true }); }
        else t.floodT = 0.2;
      }
    }),
    hook('step.after', 10, function (dt) { for (const u of this.units) if (u.floodT > 0) u.floodT -= dt; }),
  ],
  // 電腦什麼時候放這招
  ai: {
    flood: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 650,
    twelve: ({ w, u, t, d, hero, hpR, foeHeroes }) => u.lastSk != null && hero && d < 650,
  },
});
